module.exports = __webpack_public_path__ + "img/longhorn.a1716fb2.svg";